import { Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { FormControlService } from './../../shared/services/form-control.service';
import { Textbox } from './../../models/editors/textbox.model';
import { Textarea } from './../../models/editors/textarea.model';
import { Switch } from './../../models/editors/switch.model';
import { SeoSettings } from './../../models/settings/seo-settings.model';
import { ApiService } from './../../shared/services/api.service';
import { AlertService } from './../../shared/services/alert.service';
import { InlineFormBase } from './../../shared/components/base/inline-form/inline-form.base.component';

@Component({
  selector: 'swb-seo-settings',
  templateUrl: './../../shared/components/base/inline-form/inline-form.base.component.html',
  providers: [FormControlService]
})

export class SeoSettingsComponent extends InlineFormBase<SeoSettings> implements OnInit {

  public url = 'seo-settings';

  public headerTitle = 'SEO &amp; Hlavní nastavení';
  public get fieldsConfig(): Array<any> {
    return [
      new Textbox({
        key: 'title',
        label: 'Hlavní meta titulek',
        validators: [Validators.required],
        isMultilang: true
      }),
      new Textbox({
        key: 'default_title',
        label: 'Přípona meta titulku',
        validators: [Validators.required],
        isMultilang: true
      }),
      new Textbox({
        key: 'subject',
        label: 'Název subjektu',
        validators: [Validators.required],
        isMultilang: true
      }),
      new Textarea({
        key: 'description',
        label: 'Meta popisek',
        validators: [Validators.required],
        isMultilang: true
      }),
      new Textbox({
        key: 'keywords',
        label: 'klíčová slova',
        validators: [Validators.required],
        isMultilang: true
      }),
      new Switch({
        key: 'robots',
        label: 'Viditelný pro vyhledávače',
        isMultilang: false,
        labelFalse: 'Neviditelný pro vyhledávače'
      })
    ];
  }

  constructor(
    _formService: FormControlService,
    _apiService: ApiService,
    _alertService: AlertService
  ) {
    super(
      _formService,
      _apiService,
      _alertService
    );
  }

}
